// This file is auto-generated by @hey-api/openapi-ts
export const AgeClassificationPrediction = {
    PASS: 'pass',
    FAIL: 'fail',
};
export const BuzzClientAccount = {
    YELLOW: 'yellow',
    BLUE: 'blue',
    GREEN: 'green',
    FAKE_RED: 'fakeRed',
};
export const ContainerFormat = {
    MP4: 'mp4',
    WEB_M: 'webM',
};
export const FileFormat = {
    UNKNOWN: 'unknown',
    SAFE_TENSOR: 'safeTensor',
    PICKLE_TENSOR: 'pickleTensor',
    DIFFUSERS: 'diffusers',
    CORE_ML: 'coreML',
    ONNX: 'onnx',
};
export const HaiperVideoGenAspectRatio = {
    '16:9': '16:9',
    '4:3': '4:3',
    '1:1': '1:1',
    '9:16': '9:16',
    '3:4': '3:4',
};
export const HaiperVideoGenCameraMovement = {
    NONE: 'none',
    PAN_RIGHT: 'panRight',
    PAN_LEFT: 'panLeft',
    TILT_UP: 'tiltUp',
    TILT_DOWN: 'tiltDown',
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
};
export const HaiperVideoGenModel = {
    V1_5: 'v1_5',
    V2: 'v2',
};
export const HumanoidImageMaskCategory = {
    DRESSES: 'dresses',
    UPPER_BODY: 'upperBody',
    LOWER_BODY: 'lowerBody',
};
export const ImageResouceTrainingModerationStatus = {
    EVALUATING: 'evaluating',
    UNDER_REVIEW: 'underReview',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
/**
 * Available image transformers.
 */
export const ImageTransformer = {
    CANNY: 'canny',
    DEPTH_ZOE: 'depthZoe',
    SOFTEDGE_PIDINET: 'softedgePidinet',
    REMBG: 'rembg',
};
/**
 * Available levels of job support.
 */
export const JobSupport = {
    UNSUPPORTED: 'unsupported',
    UNAVAILABLE: 'unavailable',
    AVAILABLE: 'available',
};
export const KlingMode = {
    STANDARD: 'standard',
    PROFESSIONAL: 'professional',
};
export const KlingModel = {
    V1: 'v1',
    V1_5: 'v1.5',
    V1_6: 'v1.6',
    V2: 'v2',
    V2_5_TURBO: 'v2.5-turbo',
};
export const KlingVideoGenAspectRatio = {
    '16:9': '16:9',
    '9:16': '9:16',
    '1:1': '1:1',
};
export const KlingVideoGenDuration = {
    5: '5',
    10: '10',
};
export const LightricksAspectRatio = {
    '1:1': '1:1',
    '16:9': '16:9',
    '9:16': '9:16',
    '3:2': '3:2',
    '2:3': '2:3',
};
export const MiniMaxVideoGenModel = {
    HAILOU: 'hailou',
};
export const NsfwLevel = {
    PG: 'pg',
    P_G13: 'pG13',
    R: 'r',
    X: 'x',
    XXX: 'xxx',
    NA: 'na',
};
/**
 * Available options for priority.
 */
export const Priority = {
    HIGH: 'high',
    NORMAL: 'normal',
    LOW: 'low',
};
/**
 * The available options for schedulers used in image generation.
 */
export const Scheduler = {
    EULER_A: 'eulerA',
    EULER: 'euler',
    LMS: 'lms',
    HEUN: 'heun',
    DP_M2: 'dpM2',
    DP_M2A: 'dpM2A',
    DP_M2SA: 'dpM2SA',
    DP_M2M: 'dpM2M',
    DPMSDE: 'dpmsde',
    DPM_FAST: 'dpmFast',
    DPM_ADAPTIVE: 'dpmAdaptive',
    LMS_KARRAS: 'lmsKarras',
    DP_M2_KARRAS: 'dpM2Karras',
    DP_M2A_KARRAS: 'dpM2AKarras',
    DP_M2SA_KARRAS: 'dpM2SAKarras',
    DP_M2M_KARRAS: 'dpM2MKarras',
    DPMSDE_KARRAS: 'dpmsdeKarras',
    DDIM: 'ddim',
    PLMS: 'plms',
    UNI_PC: 'uniPC',
    UNDEFINED: 'undefined',
    LCM: 'lcm',
    DDPM: 'ddpm',
    DEIS: 'deis',
    DP_M3MSDE: 'dpM3MSDE',
};
export const SeedreamVersion = {
    V3: 'v3',
    V4: 'v4',
};
export const TransactionType = {
    DEBIT: 'debit',
    CREDIT: 'credit',
};
/**
 * Available statuses for updating workflows.
 */
export const UpdateWorkflowStatus = {
    CANCELED: 'canceled',
};
export const Veo3AspectRatio = {
    '16:9': '16:9',
    '9:16': '9:16',
    '1:1': '1:1',
};
export const ViduVideoGenModel = {
    DEFAULT: 'default',
    Q1: 'q1',
};
export const ViduVideoGenStyle = {
    GENERAL: 'general',
    ANIME: 'anime',
};
/**
 * Values available to represent workflow status.
 */
export const WorkflowStatus = {
    UNASSIGNED: 'unassigned',
    PREPARING: 'preparing',
    SCHEDULED: 'scheduled',
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    EXPIRED: 'expired',
    CANCELED: 'canceled',
};
/**
 * Specifies how a workflow should be upgraded when mature content is detected and green or blue buzz was used for payment.
 */
export const WorkflowUpgradeMode = {
    MANUAL: 'manual',
    AUTOMATIC: 'automatic',
};
